const fromdataedit = [
	{
			inputdata: '',
			title: '经销商类型',
			fontSize: '14px',
			color: '#333333',
			placeholder: '全部',
			types: '',
			inputtype: 'select',
			width: '210px',
			btx: true,
			// lablewith: '90px',
			options: [{
				key: "1",
				value: "哈哈哈",
			},
			{
				key: "2",
				value: "嘿嘿",
			}]
		},
		{
			inputdata: '',
			title: '产品线',
			fontSize: '14px',
			color: '#333333',
			placeholder: '全部',
			types: '',
			inputtype: 'select',
			width: '210px',
			btx: true,
			// lablewith: '90px',
			options: [{
				key: "1",
				value: "哈哈哈",
			},
			{
				key: "2",
				value: "嘿嘿",
			}]
		},
		{
			inputdata: '',
			title: '年度',
			fontSize: '14px',
			color: '#333333',
			placeholder: '全部',
			types: '',
			inputtype: 'select',
			width: '210px',
			btx: true,
			lablewith: '90px',
			options: [{
				key: "1",
				value: "哈哈哈",
			},
			{
				key: "2",
				value: "嘿嘿",
			}]
		
		},
		{
			inputdata: '',
			title: '二级经销商',
			fontSize: '14px',
			color: '#333333',
			placeholder: '全部',
			types: '',
			inputtype: 'select',
			width: '210px',
			btx: true,
			// lablewith: '90px',
			options: [{
				key: "1",
				value: "哈哈哈",
			},
			{
				key: "2",
				value: "嘿嘿",
			}]
		},
		{
			inputdata: '',
			title: '医院',
			fontSize: '14px',
			color: '#333333',
			placeholder: '全部',
			types: '',
			inputtype: 'select',
			width: '210px',
			btx: true,
			// lablewith: '110px',
			options: [{
				key: "1",
				value: "哈哈哈",
			},
			{
				key: "2",
				value: "嘿嘿",
			}]
		},
	]
export default fromdataedit;
